const moduleMap = {
	"./config-data": () => {
		return Promise.all([__webpack_require__.e(3634), __webpack_require__.e(5321), __webpack_require__.e(8262)]).then(() => (() => ((__webpack_require__(78262)))));
	},
	"./core-library-store": () => {
		return Promise.all([__webpack_require__.e(3634), __webpack_require__.e(5321), __webpack_require__.e(136)]).then(() => (() => ((__webpack_require__(40136)))));
	},
	"./event-bus": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(8044), __webpack_require__.e(9264)]).then(() => (() => ((__webpack_require__(29264)))));
	},
	"./useOpenWindow": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(3634), __webpack_require__.e(5321), __webpack_require__.e(8262), __webpack_require__.e(7718)]).then(() => (() => ((__webpack_require__(7718)))));
	},
	"./formatUrl": () => {
		return __webpack_require__.e(484).then(() => (() => ((__webpack_require__(90484)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});